
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { UserInfo } from "@/components/user/UserInfo";
import { UserAvatar } from "@/components/user/UserAvatar";
import { useUserProfile } from "@/hooks/useUserProfile";
import { ErrorState } from "@/components/owner/ErrorState";

export const ProfileSettings = () => {
  const { data: profile, isLoading, error } = useUserProfile();

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Profil</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-center p-4">
            <div className="animate-pulse">Chargement...</div>
          </div>
        </CardContent>
      </Card>
    );
  }

  if (error) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Profil</CardTitle>
        </CardHeader>
        <CardContent>
          <ErrorState message="Erreur lors du chargement du profil. Veuillez réessayer." />
        </CardContent>
      </Card>
    );
  }

  if (!profile) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Profil</CardTitle>
        </CardHeader>
        <CardContent>
          <ErrorState message="Profil non trouvé. Veuillez vous reconnecter." />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Profil</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center space-x-4">
          <UserAvatar profile={profile} />
          <div>
            <h3 className="text-lg font-medium">{profile.full_name || 'Utilisateur'}</h3>
            <p className="text-sm text-muted-foreground">{profile.email}</p>
          </div>
        </div>
        <UserInfo />
      </CardContent>
    </Card>
  );
};
